import loadAuthenticationModule from './modules/Authentication.module';
const loadShoppingBudgetModule = () => ({
    hasRouter: false,
    modules: [loadAuthenticationModule()],
});
export default loadShoppingBudgetModule;
